
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

@Component
export default class Dropdown extends Vue {
  @Prop({ default: '' }) label!: string;

  @Prop({ required: true }) items!: [];

  @Prop({ default: false }) disabled!: boolean;
}
